import { setup } from '@seek/metrics-js';
import { detect } from 'detect-browser';

import { METRIC_PREFIX } from 'src/constants/metrics';

import isMetricsEnabled from './isMetricsEnabled';
import toTags from './toTags';

const createMetrics = ({ host, environment, version, branch }: any) => {
  const prefix = METRIC_PREFIX;
  const browser = detect();
  const clientBrowser = browser ? browser.name : 'unknown browser';
  const clientOs = browser ? browser.os : 'unknown os';

  const globalTags = toTags({
    version,
    environment,
    branch,
    browser: clientBrowser,
    os: clientOs,
  });

  setup({
    host,
    isEnabled: isMetricsEnabled(environment),
    prefix,
    globalTags,
  });
};

export default createMetrics;
